import React from 'react';
import PropTypes from 'prop-types';
import { Form, Button } from 'react-bootstrap';

/**
 * Reusable chat input form used by both the full Assistant page
 * and the floating ChatWidget.
 */
export default function ChatInput({
    input,
    onInputChange,
    onSend,
    loading,
    disabled,
    placeholder,
    inputRef,
}) {
    return (
        <Form onSubmit={onSend}>
            <div className="d-flex gap-2">
                <Form.Control
                    ref={inputRef}
                    type="text"
                    placeholder={placeholder || 'Type a message...'}
                    value={input}
                    onChange={(e) => onInputChange(e.target.value)}
                    disabled={loading || disabled}
                />
                <Button
                    type="submit"
                    variant="primary"
                    disabled={loading || disabled || !input.trim()}
                >
                    Send
                </Button>
            </div>
        </Form>
    );
}

ChatInput.propTypes = {
    input: PropTypes.string.isRequired,
    onInputChange: PropTypes.func.isRequired,
    onSend: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    inputRef: PropTypes.object,
};
